module.exports = __webpack_public_path__ + "img/xuebitu.52aaa6b4.jpg";